/*
 * Copyright (c) 2026 Paxia AI Pty Ltd. All rights reserved.
 * This software is proprietary and confidential.
 * No part of this codebase may be copied, modified, published, distributed, sublicensed, or used without prior written permission from Paxia AI Pty Ltd.
 */

// Alerts API client — CRUD + events
// Uses the shared axios instance configured in src/api/api.js

import { default as api } from './api';

/**
 * @typedef {Object} Alert
 * @property {string} id
 * @property {string} name
 * @property {string} symbol
 * @property {string} timeframe
 * @property {Object} sectioned_spec
 * @property {boolean} is_active
 * @property {string=} last_triggered_at
 * @property {string} created_at
 * @property {string} updated_at
 */

/**
 * @typedef {Object} AlertEvent
 * @property {number|string} id
 * @property {string} alert
 * @property {string} ts
 * @property {Object} payload
 * @property {string} created_at
 */

export const createAlert = (payload) => api.post('/alerts/', payload);
export const listAlerts = (params) => api.get('/alerts/', { params });
export const getAlert = (id) => api.get(`/alerts/${id}/`);
export const updateAlert = (id, patch) => api.patch(`/alerts/${id}/`, patch);
export const deleteAlert = (id) => api.delete(`/alerts/${id}/`);
export const listAlertEvents = (id, params) => api.get(`/alerts/${id}/events/`, { params });

export default {
  createAlert,
  listAlerts,
  getAlert,
  updateAlert,
  deleteAlert,
  listAlertEvents,
};
